<div class="users-view" [class.small-screen-layout]="small_screen" [class.notifications-tab-active]="small_screen && selected_tab === 'notifications'" [class.notifications-editing-section]="small_screen && selected_tab === 'notifications' && editingNotificationSection !== null">
<form>
  <ion-list id="user-list" *ngIf="!small_screen">
    <ion-item-divider sticky="true" color="dark" class="header">
      <ion-label slot="start"><h4>{{ 'USERS.USER_LIST' | translate }}</h4></ion-label>
      <ion-button size="small" color="tertiary" *ngIf="!gettingUserData && canAdminister" (click)="addUser()">
        <ion-icon name="create-outline" class="icon"></ion-icon>{{ 'USERS.ADD_USER' | translate }}
      </ion-button> 
    </ion-item-divider>

     <ion-item *ngIf="gettingUserData"><ion-progress-bar type="indeterminate"></ion-progress-bar></ion-item>
     <ion-item *ngIf="!gettingUserData && canAdminister" class="filter-item">
      <ion-label>{{ 'USERS.FILTER_BY_ROLE' | translate }}</ion-label>
      <ion-select [(ngModel)]="selectedRole" interface="popover" [interfaceOptions]="{header: 'Filter Users'}">
        <ion-select-option value="all">{{ 'USERS.ALL' | translate }}</ion-select-option>
        <ion-select-option value="admin">{{ 'USERS.ADMINS' | translate }}</ion-select-option>
        <ion-select-option value="basic">{{ 'USERS.BASIC' | translate }}</ion-select-option>
        <ion-select-option value="readonly">{{ 'USERS.READONLY' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-list class="sublist" *ngIf="filteredUsers && filteredUsers.length > 0 && !gettingUserData">
      <ion-item *ngFor="let user of filteredUsers; index as i"
        (click)="selectUser(user, i)"
        [class.selected]="selected_user && ((user.email ? user.email === selected_user.email : user.username === selected_user.username) && selected_index === i)">
        <ion-label>
          <h3 class="username">
            {{user.email || user.username}}{{!user.email ? ('USERS.USERNAME' | translate) : ''}}
            <sup *ngIf="user.is_owner">{{ 'USERS.OWNER' | translate }}</sup>
            - {{user.type | titlecase}}
            <span *ngIf="isLoggedInUser(user)" class="logged-in-you">{{ 'USERS.YOU' | translate }}</span>
          </h3>
          <p class="first_last">{{user.first_name}}&nbsp;{{user.last_name}}</p>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list class="sublist" *ngIf="filteredUsers && filteredUsers.length == 0 && !gettingUserData">{{ 'USERS.NO_USERS_FOR_ROLE' | translate }}</ion-list>
  </ion-list>

  <div *ngIf="small_screen && (!filteredUsers || filteredUsers.length === 0)" class="users-empty-small ion-padding">
    <ion-item *ngIf="gettingUserData" lines="none">
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </ion-item>
    <ng-container *ngIf="!gettingUserData">
      <p class="users-empty-small-message">{{ 'USERS.NO_USERS_FOR_ROLE' | translate }}</p>
      <ion-button *ngIf="canAdminister" expand="block" color="tertiary" (click)="addUser()" class="users-empty-small-cta">
        <ion-icon name="create-outline" class="icon"></ion-icon>{{ 'USERS.ADD_USER' | translate }}
      </ion-button>
    </ng-container>
  </div>
  <div *ngIf="small_screen && filteredUsers && filteredUsers.length > 0" class="small-screen-user-select selecting-user-block">
    <div class="user-select-trigger-wrapper">
      <button type="button" class="user-select-trigger ion-activatable"
              [disabled]="!filteredUsers || filteredUsers.length === 0"
              (click)="openUserSelect()">
        <span class="user-select-text">{{ selected_user ? getSelectedUserDisplayName() : ('USERS.CHOOSE' | translate) }}</span>
        <ion-icon name="chevron-down" class="user-select-chevron"></ion-icon>
      </button>
      <ion-select #userSelect [(ngModel)]="selected_index" (ionChange)="onUserSelectChange()"
                  interface="action-sheet"
                  [interfaceOptions]="{ header: ('USERS.ALL_USERS_IN_ACCOUNT' | translate) }"
                  [disabled]="!filteredUsers || filteredUsers.length === 0"
                  class="user-select-hidden">
        <ion-select-option *ngFor="let user of filteredUsers; index as i" [value]="i">
          {{ user.email || user.username }}{{ !user.email ? ('USERS.USERNAME' | translate) : '' }} - {{ user.type | titlecase }}{{ isLoggedInUser(user) ? (' ' + ('USERS.YOU' | translate)) : '' }}
        </ion-select-option>
      </ion-select>
    </div>
  </div>
  <div id="user-account-details" *ngIf="showUserAccountDetailsPanel">
    <ion-item lines="none" class="header">
      <div class="header-flex">
        <ion-segment class="tabs" [value]="selected_tab">
          <ion-segment-button value="details" (click)="selected_tab = 'details'" [class.selected]="selected_tab === 'details'">
            <ion-label>{{ 'USERS.USER_DETAILS' | translate }}</ion-label>
          </ion-segment-button>
          <ion-segment-button value="security" (click)="selected_tab = 'security'" *ngIf="selected_user && canAdminister"
            [class.selected]="selected_tab === 'security'">
            <ion-label>{{ 'USERS.SECURITY' | translate }}</ion-label>
          </ion-segment-button>
          <ion-segment-button value="notifications" (click)="onNotificationsTabSelected()" *ngIf="selected_user && isPremiumAccount() && (isSelectedUserCurrentUser() || canAdminister)"
            [class.selected]="selected_tab === 'notifications'">
            <ion-label>{{ 'USERS.NOTIFICATIONS' | translate }}</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
    </ion-item>

    <div class="gettingData" *ngIf="gettingUserData && !createUserFormDuringAccountLoad"><ion-progress-bar type="indeterminate"></ion-progress-bar></div>
    <form class="main usersForm" *ngIf="(!gettingUserData || createUserFormDuringAccountLoad) && selected_tab === 'details'" [formGroup]="usersForm">
      <ion-item>
        <ion-label class="default-email">
          {{ 'USERS.DEFAULT_EMAIL_ADDRESS' | translate }}<sup>*</sup>
        </ion-label>
        <ion-input class="ion-text-right" formControlName="email" type="email" [placeholder]="'USERS.EMAIL_PLACEHOLDER' | translate"></ion-input>
      </ion-item>

      <ion-item *ngIf="isPremiumAccount() && selected_user && selected_user.email && (!selected_user.email_verified && !selected_user.email_verification_code)"
        class="small">
        <ion-button slot="end" (click)="verifyEmail()" class="align-top">{{ 'USERS.SEND_VERIFICATION' | translate }}</ion-button>
      </ion-item>
      <ion-item lines='none' *ngIf="isPremiumAccount() && selected_user && !selected_user.email_verified && selected_user.email_verification_code" class="email-verification">
        <ion-label>{{ 'USERS.VERIFICATION_CODE' | translate }}</ion-label>
        <ion-input class="ion-text-right" formControlName="verification_code" type="text" [placeholder]="'USERS.VERIFICATION_CODE_PLACEHOLDER' | translate"></ion-input>        
      </ion-item>
      <ion-item lines='none' *ngIf="selected_user && !selected_user.email_verified && selected_user.email_verification_code" class="email-verification">
        <ion-label>&nbsp;</ion-label>
        <ion-button slot="end" (click)="confirmEmailVerification()" type="button">{{ 'USERS.COMPLETE_VERIFICATION' | translate }}</ion-button>
        <ion-button slot="end" (click)="verifyEmail()" type="button" class="align-top">{{ 'USERS.RE_SEND_CODE' | translate }}</ion-button>    
      </ion-item>
      <ion-item *ngIf="selected_user && selected_user.email_verified" class="email-verified-message-item">
         <ion-label class="ion-text-wrap">{{ 'USERS.EMAIL_VERIFIED_MESSAGE' | translate }}</ion-label>
      </ion-item>

      <ion-item *ngIf="canAdminister">
         <ion-label>{{ 'USERS.USER_TYPE' | translate }}<sup>*</sup></ion-label>
        <ion-select class="ion-text-right" formControlName="type" [class.invalid]="!selected_user && (!usersForm.controls.type.valid && usersForm.controls.type.touched)">
          <ion-select-option value="admin">{{ 'USERS.ADMINISTRATOR' | translate }}</ion-select-option>
          <ion-select-option value="basic">{{ 'USERS.BASIC_USER' | translate }}</ion-select-option>
          <ion-select-option value="readonly">{{ 'USERS.READONLY_USER' | translate }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item>
         <ion-label>{{ 'USERS.FIRST_NAME' | translate }}<sup>*</sup></ion-label>
        <ion-input class="ion-text-right" type="text" [class.required]="!selected_user && (!usersForm.controls.first_name.valid && usersForm.controls.first_name.touched)"
          formControlName="first_name"></ion-input>
      </ion-item>

      <ion-item>
         <ion-label>{{ 'USERS.LAST_NAME' | translate }}<sup>*</sup></ion-label>
        <ion-input class="ion-text-right" type="text" [class.invalid]="!selected_user && (!usersForm.controls.last_name.valid && usersForm.controls.last_name.touched)"
          formControlName="last_name"></ion-input>
      </ion-item>
    </form>

    <form class="main" id="user-security-modal-tab" *ngIf="selected_tab === 'security' && canAdminister && kilnSecurityForm" [formGroup]="kilnSecurityForm">
      <ion-item *ngIf="!all_kilns || all_kilns.length === 0" lines="none">
        <ion-label>{{ 'KILN_LIST.NO_KILNS_AVAILABLE' | translate }}</ion-label>
      </ion-item>
      
      <div *ngIf="all_kilns && all_kilns.length > 0" class="permissions-grid" [class.four-columns]="showProgrammingToggle">
        <!-- Grid Header -->
        <div class="grid-header permissions-grid-header">
          <div class="grid-cell name-cell">{{ 'USERS.NAME' | translate }}</div>
          <div class="grid-cell checkbox-cell">
            <ion-icon name="eye-outline"></ion-icon>
            <span>{{ 'USERS.VIEW' | translate }}</span>
          </div>
          <div class="grid-cell checkbox-cell" *ngIf="showProgrammingToggle">
            <ion-icon name="code-slash-outline"></ion-icon>
            <span>{{ 'USERS.PROGRAMMING' | translate }}</span>
          </div>
          <div class="grid-cell checkbox-cell" *ngIf="showStopToggle">
            <ion-icon name="stop-circle-outline"></ion-icon>
            <span>{{ 'USERS.STOP' | translate }}</span>
          </div>
        </div>
        
        <!-- Scrollable Grid Body -->
        <div class="grid-body">
          <!-- Network Devices and Kilns -->
          <ng-container formArrayName="network_devices">
          <div *ngFor="let network_dev of kilnSecurityFormNetworkDevices(); index as network_index" [formGroupName]="network_index" class="grid-row network-device-row">
            <div class="grid-cell name-cell">
              <strong>{{network_dev.value.name}}</strong>
            </div>
            <div class="grid-cell checkbox-cell" 
                 *ngIf="network_dev.value.id !== '-1'"
                 (click)="toggleCheckbox($event, network_index, 'can_view', 'view')">
              <ion-checkbox 
                formControlName="can_view"
                (ionChange)="onNetworkDeviceViewChange(network_index, $event.detail.checked)">
              </ion-checkbox>
            </div>
            <div class="grid-cell checkbox-cell" 
                 *ngIf="network_dev.value.id === '-1'">
            </div>
            <div class="grid-cell checkbox-cell" 
                 *ngIf="showProgrammingToggle && network_dev.value.id !== '-1'"
                 (click)="toggleCheckbox($event, network_index, 'can_program', 'programming')">
              <ion-checkbox 
                formControlName="can_program"
                (ionChange)="onNetworkDeviceProgrammingChange(network_index, $event.detail.checked)">
              </ion-checkbox>
            </div>
            <div class="grid-cell checkbox-cell" 
                 *ngIf="showProgrammingToggle && network_dev.value.id === '-1'">
            </div>
            <div class="grid-cell checkbox-cell" 
                 *ngIf="showStopToggle && network_dev.value.id !== '-1'"
                 (click)="toggleCheckbox($event, network_index, 'can_stop', 'stop')">
              <ion-checkbox 
                formControlName="can_stop"
                (ionChange)="onNetworkDeviceStopChange(network_index, $event.detail.checked)">
              </ion-checkbox>
            </div>
            <div class="grid-cell checkbox-cell" 
                 *ngIf="showStopToggle && network_dev.value.id === '-1'">
            </div>
          </div>
          
          <!-- Kilns nested under network devices -->
          <ng-container *ngFor="let network_dev of kilnSecurityFormNetworkDevices(); index as network_index">
            <ng-container [formGroupName]="network_index">
              <ng-container formArrayName="kilns">
                <div *ngFor="let kiln of getKilnsForNetworkDevice(network_index); index as kiln_index" 
                     [formGroupName]="kiln_index" 
                     class="grid-row kiln-row">
                  <div class="grid-cell name-cell">
                    {{kiln.value.name}}
                  </div>
                  <div class="grid-cell checkbox-cell" (click)="toggleKilnCheckbox($event, network_index, kiln_index, 'can_view')">
                    <ion-checkbox 
                      formControlName="can_view"
                      (ionChange)="onKilnCheckboxChange(network_index, 'can_view')">
                    </ion-checkbox>
                  </div>
                  <div class="grid-cell checkbox-cell" *ngIf="showProgrammingToggle" (click)="toggleKilnCheckbox($event, network_index, kiln_index, 'can_program')">
                    <ion-checkbox 
                      formControlName="can_program"
                      (ionChange)="onKilnCheckboxChange(network_index, 'can_program')">
                    </ion-checkbox>
                  </div>
                  <div class="grid-cell checkbox-cell" *ngIf="showStopToggle" (click)="toggleKilnCheckbox($event, network_index, kiln_index, 'can_stop')">
                    <ion-checkbox 
                      formControlName="can_stop"
                      (ionChange)="onKilnCheckboxChange(network_index, 'can_stop')">
                    </ion-checkbox>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
          </ng-container>
        </div>
      </div>
    </form>

    <div id="notifications-tab" class="main notifications-tab" *ngIf="isPremiumAccount() && selected_tab === 'notifications'">
      <div class="notification-section-list" *ngIf="showNotificationSectionList">
        <div class="notification-section-card" *ngIf="showPushNotifications">
          <div class="notification-section-card-header">
            <h4>{{ 'USERS.PUSH_DEVICES' | translate }}</h4>
            <ion-button fill="clear" size="small" type="button" (click)="startEditingNotificationSection('push')">
              {{ 'USERS.EDIT' | translate }}
            </ion-button>
          </div>
          <p class="notification-section-summary">{{ getPushSectionSummaryKey() | translate:getPushSectionSummaryParams() }}</p>
        </div>

        <div class="notification-section-card" *ngIf="accountSmsEnabled">
          <div class="notification-section-card-header">
            <h4>{{ 'USERS.PRIMARY_PHONE_NUMBER' | translate }}</h4>
            <ion-button fill="clear" size="small" type="button" (click)="startEditingNotificationSection('primary_phone')">
              {{ 'USERS.EDIT' | translate }}
            </ion-button>
          </div>
          <p class="notification-section-summary">{{ getPrimaryPhoneSummaryKey() | translate:getPhoneSummaryParams(false) }}</p>
        </div>

        <div class="notification-section-card" *ngIf="accountSmsEnabled">
          <div class="notification-section-card-header">
            <h4>{{ 'USERS.SECONDARY_PHONE_NUMBER' | translate }}</h4>
            <ion-button fill="clear" size="small" type="button" (click)="startEditingNotificationSection('secondary_phone')">
              {{ 'USERS.EDIT' | translate }}
            </ion-button>
          </div>
          <p class="notification-section-summary">{{ getSecondaryPhoneSummaryKey() | translate:getPhoneSummaryParams(true) }}</p>
        </div>
      </div>

      <div class="push-form" *ngIf="showPushNotifications && shouldShowNotificationSection('push')">
        <div class="notification-edit-header" *ngIf="useFocusedNotificationEditing && editingNotificationSection === 'push'">
          <ion-button fill="clear" size="small" type="button" (click)="cancelEditingNotificationSection()">
            <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
            {{ 'USERS.BACK_TO_DEVICES' | translate }}
          </ion-button>
        </div>
        <h4 class="phone-section-title collapsible-section-toggle" *ngIf="!useFocusedNotificationEditing" (click)="togglePushNotificationsSection()" role="button" tabindex="0" (keydown.enter)="togglePushNotificationsSection()" (keydown.space)="togglePushNotificationsSection(); $event.preventDefault()">
          {{ 'USERS.PUSH_DEVICES' | translate }}
          <ion-icon [name]="showPushNotificationsSection ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </h4>
        <h4 class="phone-section-title notification-edit-title" *ngIf="useFocusedNotificationEditing && editingNotificationSection === 'push'">
          {{ 'USERS.PUSH_DEVICES' | translate }}
        </h4>
        <ion-list lines="none" *ngIf="showPushNotificationsSection || useFocusedNotificationEditing">
          <ion-item *ngIf="otherUserPushLoading" class="push-loading">
            <ion-spinner name="bubbles"></ion-spinner>
          </ion-item>

          <ion-item *ngIf="!isPushAvailable && isSelectedUserCurrentUser()" lines="none" class="push-desktop-note">
            <ion-label class="ion-text-wrap">
              <p>{{ 'USERS.PUSH_DESKTOP_SETUP_NOTE' | translate }}</p>
            </ion-label>
          </ion-item>

          <!-- Combined device list: visible for both current user and admin viewing another user -->
          <ion-item *ngIf="!accountPushEnabled" lines="none" class="push-disabled-note">
            <ion-label class="ion-text-wrap">
              <p>{{ 'GENERAL.ENABLE_PUSH_NOTIFICATIONS' | translate }}</p>
              <ion-note>{{ 'GENERAL.ENABLE_PUSH_NOTIFICATIONS_HINT' | translate }}</ion-note>
            </ion-label>
          </ion-item>

          <ion-item *ngIf="!otherUserPushLoading && accountPushEnabled && (!otherUserPushDevices || otherUserPushDevices.length === 0)" lines="none">
            <ion-label class="ion-text-wrap">
              <ion-note>{{ 'USERS.PUSH_NO_DEVICES_FOR_USER' | translate }}</ion-note>
            </ion-label>
          </ion-item>

          <ion-item *ngFor="let device of otherUserPushDevices" class="phone-item push-device-item">
            <ion-label class="ion-text-wrap">
              <h3>
                {{ device.name || ('USERS.PUSH_DEVICE' | translate) }}
                <ion-badge *ngIf="isCurrentDeviceRow(device)" color="primary">{{ 'USERS.PUSH_THIS_DEVICE_BADGE' | translate }}</ion-badge>
              </h3>
              <p *ngIf="device.platform || device.created_at">
                <span *ngIf="device.platform">{{ device.platform }}</span>
                <span *ngIf="device.platform && formatPushDeviceDate(device.created_at)"> · </span>
                <span *ngIf="formatPushDeviceDate(device.created_at)">{{ formatPushDeviceDate(device.created_at) }}</span>
              </p>
            </ion-label>
            <ion-button
              *ngIf="canTestPushDevice(device)"
              slot="end"
              fill="outline"
              size="small"
              (click)="sendTestPushToDevice(device)"
              [disabled]="pushTestingDeviceId === device.id"
              type="button">
              {{ 'USERS.PUSH_SEND_TEST' | translate }}
            </ion-button>
            <ion-spinner *ngIf="pushTestingDeviceId === device.id" slot="end" name="bubbles"></ion-spinner>
            <ion-button *ngIf="canAdminister || isSelectedUserCurrentUser()" slot="end" fill="clear" color="danger" (click)="removePushDevice(device)">
              <ion-icon name="trash-outline"></ion-icon>
            </ion-button>
          </ion-item>

          <!-- Current user: register this device -->
          <ng-container *ngIf="isSelectedUserCurrentUser()">
            <ion-item lines="none" *ngIf="isPushAvailable && pushStatusMessageKey" class="push-status-note">
              <ion-label class="ion-text-wrap">
                <ion-note>{{ pushStatusMessageKey | translate }}</ion-note>
              </ion-label>
            </ion-item>
            <ion-item class="phone-item" *ngIf="isPushAvailable">
              <ion-label class="phone-label" position="stacked">{{ 'USERS.DEVICE_NAME' | translate }}</ion-label>
              <ion-input [(ngModel)]="pushDeviceName" type="text" [placeholder]="'USERS.DEVICE_NAME_PLACEHOLDER' | translate"></ion-input>
            </ion-item>
            <ion-item lines="none" *ngIf="canRegisterAdditionalPushDevice">
              <ion-button (click)="registerPushDevice()" [disabled]="pushRegistering || !pushDeviceName?.trim()" type="button">
                {{ 'USERS.REGISTER_THIS_DEVICE' | translate }}
              </ion-button>
              <ion-spinner *ngIf="pushRegistering" name="bubbles"></ion-spinner>
            </ion-item>
          </ng-container>

          <!-- Admin viewing another user: prompt to set up push when no devices -->
          <ng-container *ngIf="canAdminister && !isSelectedUserCurrentUser()">
            <div *ngIf="!otherUserPushLoading && (!otherUserPushDevices || otherUserPushDevices.length === 0)" class="push-prompt-section">
              <ion-note>{{ 'USERS.PUSH_NO_DEVICES_FOR_USER' | translate }}</ion-note>
              <ion-item lines="none">
                <ion-button (click)="promptUserForPushNotifications()" [disabled]="!accountPushEnabled || promptPushSending" type="button">
                  {{ 'USERS.PROMPT_USER_FOR_PUSH' | translate }}
                </ion-button>
                <ion-spinner *ngIf="promptPushSending" name="bubbles"></ion-spinner>
              </ion-item>
            </div>
          </ng-container>
        </ion-list>
      </div>

      <form id="phone-section" [formGroup]="phonesForm" class="phone-section" *ngIf="accountSmsEnabled && selected_tab === 'notifications' && (shouldShowNotificationSection('primary_phone') || shouldShowNotificationSection('secondary_phone'))">
      <h4 class="phone-section-title" *ngIf="!useFocusedNotificationEditing">{{ 'USERS.TEXT_MESSAGES' | translate }}</h4>
      <div class="phone-form primary" *ngIf="shouldShowNotificationSection('primary_phone')">
        <div class="notification-edit-header" *ngIf="useFocusedNotificationEditing && editingNotificationSection === 'primary_phone'">
          <ion-button fill="clear" size="small" type="button" (click)="cancelEditingNotificationSection()">
            <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
            {{ 'USERS.BACK_TO_DEVICES' | translate }}
          </ion-button>
        </div>
        <h4 class="phone-section-title collapsible-section-toggle" *ngIf="!useFocusedNotificationEditing" (click)="togglePrimaryPhoneNumber()" role="button" tabindex="0" (keydown.enter)="togglePrimaryPhoneNumber()" (keydown.space)="togglePrimaryPhoneNumber(); $event.preventDefault()">
          {{ 'USERS.PRIMARY_PHONE_NUMBER' | translate }}
          <ion-icon [name]="showPrimaryPhoneNumber ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </h4>
        <h4 class="phone-section-title notification-edit-title" *ngIf="useFocusedNotificationEditing && editingNotificationSection === 'primary_phone'">
          {{ 'USERS.PRIMARY_PHONE_NUMBER' | translate }}
        </h4>
        <ion-list lines="none" *ngIf="showPrimaryPhoneNumber || useFocusedNotificationEditing">
          <ion-item class="phone-item" [class.invalid]="phonesForm.controls.primary_number.errors && phonesForm.controls.primary_number.errors.invalidNumber">
            <ion-label class="phone-label" position="stacked">{{ 'USERS.PHONE' | translate }}</ion-label>
            <ion-input formControlName="primary_number" type="tel" [placeholder]="'USERS.PHONE_PLACEHOLDER' | translate"></ion-input>
          </ion-item>

          <ion-item lines="none" class="phone-item checkbox" [class.invalid]="!selected_user && (!phonesForm.controls.primary_alerts_enabled.valid && phonesForm.controls.primary_alerts_enabled.touched)">
            <ion-label class="phone-label">{{ 'USERS.ENABLE_FOR_ALERTS' | translate }}</ion-label>
            <ion-checkbox formControlName="primary_alerts_enabled"></ion-checkbox>
          </ion-item>
          <ion-item lines="none" *ngIf="selected_user.primary_phone ? (selected_user.primary_phone.call_number && !selected_user.primary_phone.verified && !selected_user.primary_phone.verification_code): false">
            <ion-button slot="end" (click)="verifyPhone(false)">{{ 'USERS.SEND_VERIFICATION_PHONE' | translate }}</ion-button>
          </ion-item>
          <ion-item lines="none" class="phone-verification" *ngIf="selected_user.primary_phone ? selected_user.primary_phone.verification_code : false">
            <ion-input formControlName="verification_code" [placeholder]="'USERS.VERIFICATION_CODE_PLACEHOLDER' | translate" type="text"></ion-input>
            <ion-button (click)="confirmPhoneVerification(false)">{{ 'USERS.COMPLETE_VERIFICATION_PHONE' | translate }}</ion-button>
            <ion-button (click)="verifyPhone(false)">{{ 'USERS.RE_SEND_VERIFICATION' | translate }}</ion-button>
          </ion-item>          
          <ion-item lines="none" class="phone-actions-row" *ngIf="selected_user.primary_phone && selected_user.primary_phone.call_number">
            <ion-label *ngIf="selected_user.primary_phone && selected_user.primary_phone.verified">
              <ion-note>{{ 'USERS.PRIMARY_PHONE_VERIFIED' | translate }}</ion-note>
            </ion-label>
            <ion-button (click)="deletePhone(false)" type="button">{{ 'USERS.DELETE_PHONE' | translate }}</ion-button>
          </ion-item>
        </ion-list>
      </div>

      <div class="phone-form secondary" *ngIf="shouldShowNotificationSection('secondary_phone')">
        <div class="notification-edit-header" *ngIf="useFocusedNotificationEditing && editingNotificationSection === 'secondary_phone'">
          <ion-button fill="clear" size="small" type="button" (click)="cancelEditingNotificationSection()">
            <ion-icon slot="start" name="chevron-back-outline"></ion-icon>
            {{ 'USERS.BACK_TO_DEVICES' | translate }}
          </ion-button>
        </div>
        <h4 class="phone-section-title collapsible-section-toggle secondary-phone-toggle" *ngIf="!useFocusedNotificationEditing" (click)="toggleSecondaryPhoneNumber()" role="button" tabindex="0" (keydown.enter)="toggleSecondaryPhoneNumber()" (keydown.space)="toggleSecondaryPhoneNumber(); $event.preventDefault()">
          {{ 'USERS.SECONDARY_PHONE_NUMBER' | translate }}
          <ion-icon [name]="showSecondaryPhoneNumber ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </h4>
        <h4 class="phone-section-title notification-edit-title" *ngIf="useFocusedNotificationEditing && editingNotificationSection === 'secondary_phone'">
          {{ 'USERS.SECONDARY_PHONE_NUMBER' | translate }}
        </h4>
        <ion-list lines="none" *ngIf="showSecondaryPhoneNumber || useFocusedNotificationEditing">
          <ion-item class="phone-item" [class.invalid]="phonesForm.controls.secondary_number.errors && phonesForm.controls.secondary_number.errors.invalidNumber">
            <ion-label class="phone-label" position="stacked">{{ 'USERS.PHONE' | translate }}</ion-label>
            <ion-input formControlName="secondary_number" type="tel" [placeholder]="'USERS.PHONE_PLACEHOLDER' | translate"></ion-input>
          </ion-item>

          <ion-item lines="none" class="phone-item checkbox" [class.invalid]="!selected_user && (!phonesForm.controls.secondary_alerts_enabled.valid && phonesForm.controls.secondary_alerts_enabled.touched)">
            <ion-label class="phone-label">{{ 'USERS.ENABLE_FOR_ALERTS' | translate }}</ion-label>
            <ion-checkbox formControlName="secondary_alerts_enabled"></ion-checkbox>
          </ion-item>
          <ion-item lines="none" *ngIf="selected_user.secondary_phone ? (selected_user.secondary_phone.call_number && !selected_user.secondary_phone.verified && !selected_user.secondary_phone.verification_code) : false">
            <ion-button slot="end" (click)="verifyPhone(true)">{{ 'USERS.SEND_VERIFICATION_PHONE' | translate }}</ion-button>
          </ion-item>
          <ion-item lines="none" class="phone-verification" *ngIf="selected_user.secondary_phone ? selected_user.secondary_phone.verification_code : false">
            <ion-input formControlName="verification_code" [placeholder]="'USERS.VERIFICATION_CODE_PLACEHOLDER' | translate" type="text"></ion-input>
            <ion-button (click)="confirmPhoneVerification(true)">{{ 'USERS.COMPLETE_VERIFICATION_PHONE' | translate }}</ion-button>
            <ion-button (click)="verifyPhone(true)">{{ 'USERS.RE_SEND_VERIFICATION' | translate }}</ion-button>
          </ion-item>          
          <ion-item lines="none" *ngIf="selected_user.secondary_phone && selected_user.secondary_phone.call_number">
            <ion-label *ngIf="selected_user.secondary_phone && selected_user.secondary_phone.verified">
              <ion-note>{{ 'USERS.SECONDARY_PHONE_VERIFIED' | translate }}</ion-note>
            </ion-label>
            <ion-button slot="end" (click)="deletePhone(true)" type="button">{{ 'USERS.DELETE_PHONE' | translate }}</ion-button>
          </ion-item>
        </ion-list>
      </div>
    </form>
    </div>

    <form class="main" *ngIf="isPremiumAccount() && selected_tab === 'email'" [formGroup]="emailForm">
      <ion-list>
        <ion-item>
           <ion-label>{{ 'USERS.EMAIL_ADDRESS' | translate }}</ion-label>
          <ion-input class="ion-text-right" formControlName="email" type="email" [placeholder]="'USERS.EMAIL_ADDRESS_PLACEHOLDER' | translate"></ion-input>
        </ion-item>

        <ion-button *ngIf="selected_user && (!selected_user.email_verified && !selected_user.email_verification_code)" (click)="verifyEmail()" type="button" class="align-top">{{ 'USERS.SEND_VERIFICATION' | translate }}</ion-button>
        <ion-item *ngIf="selected_user && !selected_user.email_verified && selected_user.email_verification_code" class="vertical">
          <ion-input class="ion-text-right" formControlName="verification_code" type="text"></ion-input>
          <ion-button (click)="confirmEmailVerification()" class="align-top" type="button">{{ 'USERS.COMPLETE_VERIFICATION' | translate }}</ion-button>
        </ion-item>
        <ion-note *ngIf="selected_user && selected_user.email_verified">
          {{ 'USERS.EMAIL_VERIFIED_MESSAGE' | translate }}
        </ion-note>
      </ion-list>
    </form>
  </div>  
</form>

<ion-row class="ion-padding-end submit-row"
    [class.small-screen-actions]="small_screen"
    [class.submit-row--notifications-tab]="small_screen && selected_tab === 'notifications'"
    [class.small-screen-admin-editor-footer]="small_screen && canAdminister && showUserAccountDetailsPanel && !smallScreenAwaitingUserPick">
  <ion-button *ngIf="small_screen && canAdminister && smallScreenAwaitingUserPick" color="tertiary" (click)="addUser()" class="add-user-btn">
    <ion-icon name="create-outline" class="icon"></ion-icon>{{ 'USERS.ADD_USER' | translate }}
  </ion-button>
  <ng-container *ngIf="!small_screen">
    <div class="delete-user-action"
        *ngIf="!gettingUserData && canAdminister && selected_user && showUserAccountDetailsPanel">
      <ion-button
        fill="outline"
        color="danger"
        type="button"
        class="delete-btn"
        [disabled]="deletePending || !canDeleteSelectedUser"
        (click)="removeUser()">
        <ion-icon slot="start" name="trash-outline"></ion-icon>
        {{ 'USERS.DELETE_USER' | translate }}
      </ion-button>
      <p class="delete-user-disabled-hint" *ngIf="!canDeleteSelectedUser && !deletePending">
        {{ 'USERS.DELETE_USER_SOLE_ACCOUNT' | translate }}
      </p>
    </div>
    <div class="submit-row-spacer"></div>
    <div class="submit-row-end">
      <ion-button type="submit"
          [disabled]="!isValid()"
          (click)="save()" *ngIf="!updatePending && showUserAccountDetailsPanel">{{ 'USERS.SUBMIT' | translate }}</ion-button>
      <div *ngIf="updatePending && showUserAccountDetailsPanel" class="submitpending">
        <ion-spinner name='bubbles'></ion-spinner>
        <span>{{ 'USERS.UPDATING' | translate }}</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="small_screen && canAdminister && showUserAccountDetailsPanel && !smallScreenAwaitingUserPick">
    <div class="submit-row-small-footer">
      <div class="submit-row-editor-pair">
        <ion-button type="button" fill="outline" color="medium" *ngIf="!updatePending" (click)="cancelSmallScreenUserEditor()">
          {{ 'USERS.CANCEL' | translate }}
        </ion-button>
        <div class="submit-row-end">
          <ion-button type="submit"
              [disabled]="!isValid()"
              (click)="save()" *ngIf="!updatePending">
            {{ selected_user ? ('USERS.UPDATE' | translate) : ('USERS.SUBMIT' | translate) }}
          </ion-button>
          <div *ngIf="updatePending" class="submitpending">
            <ion-spinner name='bubbles'></ion-spinner>
            <span>{{ 'USERS.UPDATING' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="delete-user-action delete-user-action--footer" *ngIf="!gettingUserData && selected_user">
        <ion-button
          expand="block"
          fill="outline"
          color="danger"
          type="button"
          class="delete-btn delete-btn--footer"
          [disabled]="deletePending || !canDeleteSelectedUser"
          (click)="removeUser()">
          <ion-icon slot="start" name="trash-outline"></ion-icon>
          {{ 'USERS.DELETE_USER' | translate }}
        </ion-button>
        <p class="delete-user-disabled-hint" *ngIf="!canDeleteSelectedUser && !deletePending">
          {{ 'USERS.DELETE_USER_SOLE_ACCOUNT' | translate }}
        </p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="small_screen && !canAdminister && showUserAccountDetailsPanel">
    <div class="submit-row-end submit-row-end--small-only">
      <ion-button expand="block" type="button"
          [disabled]="!isValid()"
          (click)="save()" *ngIf="!updatePending">
        {{ selected_user ? ('USERS.UPDATE' | translate) : ('USERS.SUBMIT' | translate) }}
      </ion-button>
      <div *ngIf="updatePending" class="submitpending">
        <ion-spinner name='bubbles'></ion-spinner>
        <span>{{ 'USERS.UPDATING' | translate }}</span>
      </div>
    </div>
  </ng-container>
</ion-row>
</div>